export const GetFullParamsService = Symbol('GetFullParamsService');

export interface GetFullParamsService {
    getFullParams: (patentId: string) => Promise<{
        data: Record<string, string>;
        params: Record<string, string>;
    }>;
}
